import React from "react"
import { AccountingRuleFormType } from ".."
import apiServerApi from "../../../redux/sagas/apiServerApi"
import SimpleAccountingRuleForm from "../SimpleAccountingRuleForm"

export default function DefaultedLoanAccountingForm({ isUpdate }) {
  return (
    <SimpleAccountingRuleForm
      uri='/defaultedloanaccounting'
      text='Accounting for defaulted loans'
      info='Gl accounts to be used for defaulted loans'
      loadConfig={ apiServerApi.getDefaultedLoanAccountingRule }
      saveConfig={ apiServerApi.saveDefaultedLoanAccountingRule }
      isUpdate={ isUpdate }
      accountingRuleFormType={ AccountingRuleFormType.OTHER }
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/Accounting/DefaultedLoanAccounting/Form.js